import { ActionsEnum } from "../../../assets/utils/enums/settings";
import { BodyDiv } from "../../components-style";
import { LittleSubHeadline, LittleText, SubTitle } from "../../typography";
import CommentItem, { CommentsBlock } from "./comment-block";
import { ErrorBlock } from "../table";
import { CommentType } from "../../../assets/utils/enums/project";
import { formatDate } from "../../../assets/utils/date-formatter";
import CustomToast from "../custom-toast";
import toast from "react-hot-toast";
import { ToastTypeEnum } from "../../../assets/utils/enums/toast";
import { authFetch } from "../../../api/authFetch";
import { API_URL_COMMENT } from "../../../constants";
import { ModalWindowType } from "../modal-window";

export default function CommentListDetails(
    { comments, setIsChangedComment, setModalWindowSettings, setIsLoading }:
        { comments: CommentType[]; setIsChangedComment: React.Dispatch<React.SetStateAction<boolean>>; setModalWindowSettings: React.Dispatch<React.SetStateAction<ModalWindowType>>;setIsLoading: React.Dispatch<React.SetStateAction<boolean>> }) {

    const groupCommentsByDate = (commentsData: CommentType[]) => {
        const sorted = [...commentsData].sort(
            (a, b) =>
                new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime()
        );

        const grouped: Record<string, CommentType[]> = {};
        sorted.forEach((comment) => {
            const dateKey = formatDate(comment.createdAt);
            if (!grouped[dateKey]) {
                grouped[dateKey] = [];
            }
            grouped[dateKey].push(comment);
        });

        return grouped;
    };

    async function handleDeleteComment(commentId: number) {
        const response = await authFetch(`${API_URL_COMMENT}/delete/${commentId}`, {
            method: "DELETE",
            credentials: "include",
        });

        if (response.ok) {
            toast((t) => (
                <CustomToast
                    t={t}
                    type={ToastTypeEnum.INFO}
                    text={"Видалення коментаря успішне."}
                />
            ));
        }
        setIsChangedComment(true);
        setModalWindowSettings((prev) => ({ ...prev, isOpen: false }));
    }

    const handleUpdateComment = async (id: number, commentValue: string) => {
        try {
            setIsLoading(true);
            if (!commentValue) return;

            const response = await authFetch(`${API_URL_COMMENT}/update-comment?commentId=${id}&content=${commentValue}`, {
                method: "PUT",
                headers: { "Content-Type": "application/json" },
                credentials: "include",
            });

            if (!response.ok) {
                toast((t) => (
                    <CustomToast
                        t={t}
                        type={ToastTypeEnum.WARNING}
                        text={"Перевірте коректність введення даних!"}
                    />
                ));
                return;
            }
            toast((t) => (
                <CustomToast
                    t={t}
                    type={ToastTypeEnum.SUCCESS}
                    text={"Коментар оновлено!"}
                />
            ));
            setTimeout(() => {
                setIsChangedComment(true);
            }, 300);
        } catch (error) {
            console.error("Fetch error:", error);
            toast((t) => (
                <CustomToast
                    t={t}
                    text={"Упс, щось пішло не так\nПроблема з сервером."}
                    type={ToastTypeEnum.ERROR}
                />
            ));
        } finally {
            setTimeout(() => {
                setIsLoading(false);
            }, 150);
        }
    };

    return (
        <BodyDiv data-class="add-comment">
            <SubTitle>Коментарі</SubTitle>
            {comments.length === 0 ? (
                <ErrorBlock>
                    <LittleSubHeadline>
                        Коментарі для цієї продажі відсутні
                    </LittleSubHeadline>
                </ErrorBlock>
            ) : (
                Object.entries(groupCommentsByDate(comments)).map(
                    ([date, comments]) => (
                        <CommentsBlock key={date}>
                            <LittleText>{date}</LittleText>
                            {comments.map((comment) => (
                                <CommentItem
                                    key={comment.id}
                                    item={comment}
                                    deleteClick={() => {
                                        setModalWindowSettings({
                                            isOpen: true,
                                            onConfirm: () => handleDeleteComment(comment.id),
                                            onCancel: () =>
                                                setModalWindowSettings((prev) => ({
                                                    ...prev,
                                                    isOpen: false,
                                                })),
                                            action: ActionsEnum.DELETE,
                                        });
                                    }}
                                    editClick={handleUpdateComment}
                                />
                            ))}
                        </CommentsBlock>
                    )
                )
            )}
        </BodyDiv>
    )
}